var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-2 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "egg [#87]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-102.000000, -7839.000000)",
    fill: "#b0b0b0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7992073,7695.99612 C52.4054587,7695.78987 50.7846842,7691.57789 53.1936712,7689.18506 C55.5976184,7686.79723 59.8440879,7688.40013 60.0497085,7691.77412 C57.2949967,7689.35926 53.3650217,7693.25487 55.7992073,7695.99612 M58.7504683,7694.73963 C57.8806123,7695.56261 56.5168637,7694.36018 57.2677822,7693.41206 C57.9703194,7692.52301 59.7301902,7693.34498 58.7504683,7694.73963 M47.9785672,7691.01422 C47.9785672,7687.76437 49.4783884,7683.59143 52.2099175,7681.60208 C55.3174099,7679.3414 58.1688844,7684.56659 59.099217,7686.83828 C56.3757514,7685.2484 52.7925093,7686.06536 51.0286068,7688.65843 C49.2576486,7691.26252 49.8684628,7694.8858 52.3832839,7696.79006 C49.846288,7696.07621 47.9785672,7693.76047 47.9785672,7691.01422 M61.2834324,7686.90736 C60.1877969,7683.80168 57.596372,7679 53.7127625,7679 C50.2897836,7679 48.1186715,7682.96069 47.0734332,7685.69192 C45.7973757,7689.02587 45.301467,7692.88143 47.6308264,7695.89099 C50.1930209,7699.20191 55.0472808,7699.99986 58.537792,7697.64707 C62.2278763,7695.16213 62.6522208,7690.78595 61.2834324,7686.90736",
    id: "egg-[#87]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d37936a3f3f4f22f8a6452f20ffe939b.svg";
export { ForwardRef as ReactComponent };